import Scales from "./Scales";

export default {
  checkIfChartHasScale(_, chart) {
    return Scales.checkIfChartHasScale(chart);
  },
  mountActiveScaleForChart(_, { chart, scale }) {
    return Scales.mountActiveScaleForChart(scale, chart);
  }
};
